export const routes = [
  {
    path: '/',
    name: '/',
    component: () => import('C:/Users/whb08/Workspace/ECI/audit/cast-frontend-v2/src/pages/index.vue'),
    /* no children */
    meta: {
      "layout": "Editor"
    }
  },
  {
    path: '/:all(.*)',
    name: '/[...all]',
    component: () => import('C:/Users/whb08/Workspace/ECI/audit/cast-frontend-v2/src/pages/[...all].vue'),
    /* no children */
    meta: {
      "layout": 404
    }
  },
  {
    path: '/auth',
    /* internal name: '/auth' */
    /* no component */
    children: [
      {
        path: '',
        name: '/auth/',
        component: () => import('C:/Users/whb08/Workspace/ECI/audit/cast-frontend-v2/src/pages/auth/index.vue'),
        /* no children */
        meta: {
          "layout": "Auth"
        }
      },
      {
        path: 'client',
        name: '/auth/client',
        component: () => import('C:/Users/whb08/Workspace/ECI/audit/cast-frontend-v2/src/pages/auth/client.vue'),
        /* no children */
        meta: {
          "layout": "Auth"
        }
      },
      {
        path: 'logout',
        name: '/auth/logout',
        component: () => import('C:/Users/whb08/Workspace/ECI/audit/cast-frontend-v2/src/pages/auth/logout.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/client',
    /* internal name: '/client' */
    /* no component */
    children: [
      {
        path: '',
        name: '/client/',
        component: () => import('C:/Users/whb08/Workspace/ECI/audit/cast-frontend-v2/src/pages/client/index.vue'),
        /* no children */
        meta: {
          "layout": "Client"
        }
      },
      {
        path: ':id',
        /* internal name: '/client/[id]' */
        /* no component */
        children: [
          {
            path: '',
            name: '/client/[id]/',
            component: () => import('C:/Users/whb08/Workspace/ECI/audit/cast-frontend-v2/src/pages/client/[id]/index.vue'),
            /* no children */
            meta: {
              "layout": "Client"
            }
          },
          {
            path: 'character',
            /* internal name: '/client/[id]/character' */
            /* no component */
            children: [
              {
                path: ':id',
                /* internal name: '/client/[id]/character/[id]' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '/client/[id]/character/[id]/',
                    component: () => import('C:/Users/whb08/Workspace/ECI/audit/cast-frontend-v2/src/pages/client/[id]/character/[id]/index.vue'),
                    /* no children */
                    meta: {
                      "layout": "Client"
                    }
                  },
                  {
                    path: 'talent',
                    /* internal name: '/client/[id]/character/[id]/talent' */
                    /* no component */
                    children: [
                      {
                        path: ':id',
                        /* internal name: '/client/[id]/character/[id]/talent/[id]' */
                        /* no component */
                        children: [
                          {
                            path: '',
                            name: '/client/[id]/character/[id]/talent/[id]/',
                            component: () => import('C:/Users/whb08/Workspace/ECI/audit/cast-frontend-v2/src/pages/client/[id]/character/[id]/talent/[id]/index.vue'),
                            /* no children */
                            meta: {
                              "layout": "Client"
                            }
                          }
                        ],
                      }
                    ],
                  }
                ],
              }
            ],
          }
        ],
      }
    ],
  },
  {
    path: '/editor',
    /* internal name: '/editor' */
    /* no component */
    children: [
      {
        path: '',
        name: '/editor/',
        component: () => import('C:/Users/whb08/Workspace/ECI/audit/cast-frontend-v2/src/pages/editor/index.vue'),
        /* no children */
        meta: {
          "layout": "Editor"
        }
      },
      {
        path: 'admin',
        /* internal name: '/editor/admin' */
        /* no component */
        children: [
          {
            path: '',
            name: '/editor/admin/',
            component: () => import('C:/Users/whb08/Workspace/ECI/audit/cast-frontend-v2/src/pages/editor/admin/index.vue'),
            /* no children */
            meta: {
              "layout": "Editor"
            }
          },
          {
            path: 'user',
            name: '/editor/admin/user',
            component: () => import('C:/Users/whb08/Workspace/ECI/audit/cast-frontend-v2/src/pages/editor/admin/user.vue'),
            /* no children */
            meta: {
              "layout": "Editor"
            }
          }
        ],
      },
      {
        path: 'category',
        /* internal name: '/editor/category' */
        /* no component */
        children: [
          {
            path: ':name',
            name: '/editor/category/[name]',
            component: () => import('C:/Users/whb08/Workspace/ECI/audit/cast-frontend-v2/src/pages/editor/category/[name].vue'),
            /* no children */
            meta: {
              "layout": "Editor"
            }
          }
        ],
      },
      {
        path: 'inbox',
        /* internal name: '/editor/inbox' */
        /* no component */
        children: [
          {
            path: '',
            name: '/editor/inbox/',
            component: () => import('C:/Users/whb08/Workspace/ECI/audit/cast-frontend-v2/src/pages/editor/inbox/index.vue'),
            /* no children */
            meta: {
              "layout": "Editor"
            }
          }
        ],
      },
      {
        path: 'portfolio',
        /* internal name: '/editor/portfolio' */
        /* no component */
        children: [
          {
            path: '',
            name: '/editor/portfolio/',
            component: () => import('C:/Users/whb08/Workspace/ECI/audit/cast-frontend-v2/src/pages/editor/portfolio/index.vue'),
            /* no children */
            meta: {
              "layout": "Editor"
            }
          },
          {
            path: ':id',
            name: '/editor/portfolio/[id]',
            component: () => import('C:/Users/whb08/Workspace/ECI/audit/cast-frontend-v2/src/pages/editor/portfolio/[id].vue'),
            /* no children */
            meta: {
              "layout": "Editor"
            }
          },
          {
            path: 'new',
            name: '/editor/portfolio/new',
            component: () => import('C:/Users/whb08/Workspace/ECI/audit/cast-frontend-v2/src/pages/editor/portfolio/new.vue'),
            /* no children */
            meta: {
              "layout": "Editor"
            }
          }
        ],
      },
      {
        path: 'talent',
        /* internal name: '/editor/talent' */
        /* no component */
        children: [
          {
            path: '',
            name: '/editor/talent/',
            component: () => import('C:/Users/whb08/Workspace/ECI/audit/cast-frontend-v2/src/pages/editor/talent/index.vue'),
            /* no children */
            meta: {
              "layout": "Editor"
            }
          },
          {
            path: ':id',
            name: '/editor/talent/[id]',
            component: () => import('C:/Users/whb08/Workspace/ECI/audit/cast-frontend-v2/src/pages/editor/talent/[id].vue'),
            /* no children */
            meta: {
              "layout": "Editor"
            }
          }
        ],
      },
      {
        path: 'talent-groups',
        /* internal name: '/editor/talent-groups' */
        /* no component */
        children: [
          {
            path: '',
            name: '/editor/talent-groups/',
            component: () => import('C:/Users/whb08/Workspace/ECI/audit/cast-frontend-v2/src/pages/editor/talent-groups/index.vue'),
            /* no children */
            meta: {
              "layout": "Editor"
            }
          },
          {
            path: ':id',
            name: '/editor/talent-groups/[id]',
            component: () => import('C:/Users/whb08/Workspace/ECI/audit/cast-frontend-v2/src/pages/editor/talent-groups/[id].vue'),
            /* no children */
            meta: {
              "layout": "Editor"
            }
          }
        ],
      },
      {
        path: 'voice-picker',
        /* internal name: '/editor/voice-picker' */
        /* no component */
        children: [
          {
            path: '',
            name: '/editor/voice-picker/',
            component: () => import('C:/Users/whb08/Workspace/ECI/audit/cast-frontend-v2/src/pages/editor/voice-picker/index.vue'),
            /* no children */
            meta: {
              "layout": "Editor"
            }
          }
        ],
      }
    ],
  }
]

export function handleHotUpdate(_router, _hotUpdateCallback) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
    import.meta.hot.data.router_hotUpdateCallback = _hotUpdateCallback
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    // call the hotUpdateCallback for custom updates
    import.meta.hot.data.router_hotUpdateCallback?.(mod.routes)
    const route = router.currentRoute.value
    router.replace({
      ...route,
      // NOTE: we should be able to just do ...route but the router
      // currently skips resolving and can give errors with renamed routes
      // so we explicitly set remove matched and name
      name: undefined,
      matched: undefined,
      force: true
    })
  })
}

